export enum SearchExpenseCategoryEnum {
  NONE = "NONE",
  ID_EXPENSE = "ID_EXPENSE",
  INVOICE_NUMBER = "INVOICE_NUMBER",
  ID_TRADE = "ID_TRADE"
}

export const SearchExpenseCategoryLabel = new Map<SearchExpenseCategoryEnum, string>([
  [SearchExpenseCategoryEnum.NONE, "Sem filtro"],
  [SearchExpenseCategoryEnum.ID_EXPENSE, "ID da solicitação de pagamento"],
  [SearchExpenseCategoryEnum.INVOICE_NUMBER, "N° NF/ND"],
  [SearchExpenseCategoryEnum.ID_TRADE, "Id do Trade"]
]);



// WEBPACK FOOTER //
// ./src/services/Enum/SearchExpenseCategoryEnum.ts